module.exports = __webpack_public_path__ + "static/reel_final-0ee8e4dac24e08c696edc1860fdfeca0.mp4";